/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgCircle8 = (props: Props) => (
  <Icon viewBox="0 0 8 8" {...props}>
    <path
      d="M4 8C1.795 8 0 6.205 0 4s1.795-4 4-4 4 1.795 4 4-1.795 4-4 4"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgCircle8 as Circle8 };
